import { Scenario } from 'types';
import useAuthQuery from './useAuthQuery';

export const useScenarios = () => useAuthQuery<Scenario[]>(['scenarios']);

export const useScenario = (id: number) => {
  return useAuthQuery<Scenario>(['scenarios', id]);
};
